import { Column } from 'react-table';
import clsx from 'clsx';
import { useRecordTable } from '../../../hooks/useRecordTable';
import SettlementTableHeader from './SettlementTableHeader';
import SettlementTableBody from './SettlementTableBody';

export type CustomColumn<T extends object> = Column<T> & {
  customCell?: (cell: any) => JSX.Element | string;
  className?: string;
};

interface SettlementTableProps<T extends object> {
  columns: CustomColumn<T>[];
  data: T[];
  actions?: any;
  pageSize?: number;
  noDataMessage?: string;
  showFilters?: boolean;
  maxWidth?: string;
  title?: string; // 🆕 Título de la tabla
}

const SettlementTable = <T extends object>({
  columns,
  data,
  actions,
  pageSize = 10,
  noDataMessage = 'No hay registros disponibles.',
  showFilters = false,
  maxWidth = 'max-w-6xl',
  title,
}: SettlementTableProps<T>) => {
  const table = useRecordTable<T>({ columns, data, pageSize });

  return (
    <div
      className={clsx(
        'mt-6 w-full rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark',
        maxWidth
      )}
    >
      {title && (
        <div className="border-b border-stroke px-4 pb-3 pt-4 dark:border-strokedark">
          <h3 className="text-lg font-semibold text-black dark:text-white">
            {title}
          </h3>
        </div>
      )}

      <section className="data-table-common data-table-two bg-white py-4 dark:bg-boxdark">
        <div className="w-full overflow-x-auto p-2">
          <table
            {...table.getTableProps()}
            className="datatable-table w-full min-w-[700px] table-auto border-collapse break-words md:table-fixed md:overflow-auto"
          >
            <SettlementTableHeader
              table={table}
              showFilters={showFilters}
              actions={actions}
            />
            <SettlementTableBody
              table={table}
              actions={actions}
              noDataMessage={noDataMessage}
            />
          </table>
        </div>
      </section>
    </div>
  );
};

export default SettlementTable;
